import * as Sentry from '@sentry/astro';

Sentry.init({
  dsn: import.meta.env.PUBLIC_SENTRY_DSN,
  environment: import.meta.env.PUBLIC_HR_ENV,
  tracesSampleRate: 0.01, // Sets the sample rate at 1%
  tracePropagationTargets: ['localhost', /^https:\/\/.*\.hungryroot\.com\/api/],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  ignoreErrors: ['Load failed'],
});
